﻿import URLSearchParams from '@ungap/url-search-params'

export const setSearchHistory = (newParams, replace) => {
  const params = new URLSearchParams(window.location.search);

  if(newParams && newParams.name)
    params.set('name', newParams.name);

  if(newParams && newParams.address)
    params.set('address', newParams.address);

  if(newParams && newParams.position && newParams.position.lat)
    params.set('lat', newParams.position.lat);

  if(newParams && newParams.position && newParams.position.lng)
    params.set('lng', newParams.position.lng);

  if(newParams && newParams.date)
    params.set('date', newParams.date);

  if(newParams && newParams.items)
    params.set('items', newParams.items);

  const newUrl = window.location.origin + window.location.pathname + '?' + params.toString();

  if(replace)
    history.replaceState(newParams, document.title, newUrl)
  else
    history.pushState(newParams, document.title, newUrl)
}

export const paramsToObject = (paramsObject) => {
  const result = {}
  for(const [key, value] of paramsObject) {
    result[key] = value;
  }
  return result;
}

export const setBookingflowStep = (stepIndex) => {
  const state = { activeStep: stepIndex }
  const title = document.title;
  const url = window.location.origin + window.location.pathname + window.location.search;

  history.pushState(state, title, url)

  console.log('pushState', state)
}